import axios, { AxiosRequestConfig } from 'axios';
import { v4 as uuid } from 'uuid';
import { unmarshallSuccess, unmarshallFailure } from './marshaller';

declare global {
  interface Window {
    transactionId: string;
  }
}
window.transactionId = window.transactionId || uuid();
const tracingHeaders = {
  'X-Transaction-Id': window.transactionId,
  MsgTransactionId: window.transactionId,
};

export default (baseUrl: string) => ({
  get: (path: string, params: AxiosRequestConfig['params'] = {}) =>
    axios
      .get(`${baseUrl}${path}`, {
        params,
        headers: tracingHeaders,
      })
      .then(unmarshallSuccess)
      .catch(unmarshallFailure),

  post: (
    path: string,
    body: unknown,
    auth?: { username: string; password: string }
  ) =>
    axios
      .post(
        `${baseUrl}${path}`,
        body,
        auth ? { auth } : { headers: tracingHeaders }
      )
      .then(unmarshallSuccess)
      .catch(unmarshallFailure),
});
